export const lotsReducer = (state = {loading: false, resultlot: null, lots: [], lotsForSelect: [], lot: null, total: 0} , action) => {
    switch (action.type) {
        case 'LOT_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                lots: action.payload.lots,
                total: action.payload.total
            }
        case 'LOT_GETALLFORSELECT_SUCCESS':
            return {
                ...state,
                lotsForSelect: action.payload
            }
        case 'LOT_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                lot: action.payload.lot
            }
        case 'LOT_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultlot: action.payload.message,
                lot: action.payload.lot,
                lots: [...state.lots, action.payload.lot],
            }
        case 'LOT_WRONG_SUCCESS':
            return {
                ...state,
                loading: false,
                resultlot: action.payload.message
            }
        case 'LOT_EDIT_SUCCESS':
            if(action.payload.lot){
                return {
                    ...state,
                    loading: false,
                    resultlot: action.payload.message,
                    lot: action.payload.lot,
                    lots: state.lots.map(lot => lot._id === action.payload.lot._id ? action.payload.lot : lot),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultlot: action.payload
                }
            }
        case 'LOT_RESET_RESULT':
            return {
                ...state,
                resultlot: null
            }
        case 'LOT_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'LOT_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}
